import React from "react";
import { Table } from "react-bootstrap";
import { formatUSD, formatPercentage } from "../../utils/format";
import BorrowableDetailsRow from "./BorrowableDetailsRow";
import { useTokenIcon } from "../../hooks/useUrlGenerator";
import useGenericCall from "../../hooks/useGenericCall";
import { useOffchainBorrowable } from '../../hooks/useOffchain';
import { switchChainDataMap } from '../../utils/connections';
import { useNetworkName } from "../../hooks/useNetwork";

/**
 * Generate the Currency Equity Details card, giving information about the suppy and rates for a particular currency in
 * the system.
 */
export default function BorrowableDetails() {
  const data = useGenericCall(useOffchainBorrowable(), async offchainBorrowable => ({
    name: await offchainBorrowable.getName(),
    symbol: await offchainBorrowable.getSymbol(),
    supplyUSD: await offchainBorrowable.getSupplyUSD(),
    totalBorrowsUSD: await offchainBorrowable.getTotalBorrowsUSD(),
    utilizationRate: await offchainBorrowable.getUtilizationRate(),
    kinkUtilizationRate: await offchainBorrowable.getKinkUtilizationRate(),
    supplyAPR: await offchainBorrowable.getSupplyAPR(),
    borrowAPR: await offchainBorrowable.getBorrowAPR(),
    farmingAPR: await offchainBorrowable.getFarmingAPR(),
    id: (await offchainBorrowable.getPoolTokenData()).id
  }));
  const tokenIcon = useTokenIcon();
  const networkName = useNetworkName();

  if (!data) return (null);

  return (<div className="borrowable-details"> 
    <div className="header">
      <img className="currency-icon" src={tokenIcon} />
      {data.name} ({data.symbol})
      <a href={switchChainDataMap[networkName].blockExplorerUrls[0] + "address/" + data.id}
        title="borrowable"
        target="_blank"
        style={{ textDecoration: "none" }}>&nbsp;🔗</a>
    </div>
    <Table>
      <tbody>
        <BorrowableDetailsRow name={"Total Supply"} value={formatUSD(data.supplyUSD)} />
        <BorrowableDetailsRow name={"Total Borrow"} value={formatUSD(data.totalBorrowsUSD)} />
        <BorrowableDetailsRow name={"Utilization Rate"} value={formatPercentage(data.utilizationRate)} />
        <BorrowableDetailsRow name={"Kink Utilization Rate"} value={formatPercentage(data.kinkUtilizationRate)} />
        <BorrowableDetailsRow name={"Supply APR"} value={formatPercentage(data.supplyAPR)} />
        <BorrowableDetailsRow name={"Borrow APR"} value={formatPercentage(data.borrowAPR)} />
        { data.farmingAPR > 0 && (<BorrowableDetailsRow name={"Farming APR"} value={formatPercentage(data.farmingAPR)} />) }
      </tbody>  
    </Table>
  </div>);
}
